// src/locales/ta/storePickup.js
export const storePickup = {
  // Page
  pageTitle: "Store Pickup ஆர்டர்கள்",
  pageDescription: "நேரடியாக எடுத்துச் செல்லப்படும் ஆர்டர்களை அனுப்புகை வரை கண்காணிக்கவும்",
  searchPlaceholder: "ஆர்டர் எண், வாடிக்கையாளர் பெயர் அல்லது தொலைபேசி எண் மூலம் தேடவும்...",
  orderDate: "ஆர்டர் தேதி",

  // Columns
  orderNumber: "ஆர்டர் #",
  customerName: "வாடிக்கையாளர்",
  phone: "தொலைபேசி",
  deliveryNotes: "டெலிவரி குறிப்புகள்",
  deliveryNotesPlaceholder: "குறிப்பு சேர்க்கவும்...",
  deliveryNotesSaveFailed: "டெலிவரி குறிப்புகளை சேமிக்க முடியவில்லை",

  // Row actions
  viewOrder: "ஆர்டரைப் பார்க்க",
  viewPaymentRecords: "பணம் செலுத்திய பதிவுகளைப் பார்க்க",
  paymentRecords: "பணம் செலுத்திய பதிவுகள்",
  dispatch: "அனுப்பு",
  dispatchBlockedUnverified: "சரிபார்க்கப்படாத பணம் செலுத்திய பதிவு இருக்கும்போது அனுப்புதல் தடுக்கப்படும்",

  // Dispatch modal
  dispatchOrder: "ஆர்டரை அனுப்பு",
  warehouse: "கிடங்கு",
  selectWarehouse: "ஒரு கிடங்கைத் தேர்ந்தெடுக்கவும்",
  warehouseRequired: "தயவுசெய்து ஒரு கிடங்கைத் தேர்ந்தெடுக்கவும்",
  dispatchedDate: "அனுப்பிய தேதி",
  backdateNotAllowed: "அனுப்பிய தேதியை முந்தைய தேதிக்கு மாற்ற உங்களுக்கு அனுமதி இல்லை",
  dispatchSuccess: "ஆர்டர் வெற்றிகரமாக அனுப்பப்பட்டது",
  dispatchFailed: "ஆர்டரை அனுப்ப முடியவில்லை",

  // Empty / error states
  noOrdersFound: "Store Pickup ஆர்டர்கள் எதுவும் இல்லை",
  noOrdersFoundDescription: "Store Pickup பணம் செலுத்தும் வகை கொண்ட ஆர்டர்கள் இங்கே தோன்றும்",
  failedToLoad: "Store Pickup ஆர்டர்களை ஏற்ற முடியவில்லை",

  // Open in POS
  deletePayment: "கட்டணத்தை நீக்கு",
  confirmDeletePayment: "இந்த சரிபார்க்கப்படாத கட்டணப் பதிவை நீக்கவா?",
  deletePaymentSuccess: "கட்டணப் பதிவு நீக்கப்பட்டது",
  deletePaymentFailed: "கட்டணப் பதிவை நீக்க முடியவில்லை",
  verifiedLocked: "சரிபார்க்கப்பட்ட கட்டணங்களை மாற்ற முடியாது",
  openInPos: "POS டெர்மினலில் திற",
  selectPosShop: "POS டெர்மினலைத் தேர்ந்தெடு",
  posShop: "POS டெர்மினல்",
  open: "திற",
  noPosShop: "நீங்கள் எந்த POS டெர்மினல் கடைக்கும் ஒதுக்கப்படவில்லை",
};
